import React from "react";
import Send_Btn_1 from "assets/icons/botIcon-1.svg";
import Send_Btn_2 from "assets/icons/botIcon-2.svg";
import Send_Btn_3 from "assets/icons/botIcon-3.svg";
import Send_Btn_4 from "assets/icons/botIcon-4.svg";
import Avatar_5 from "assets/icons/avatar-5.svg";

const SendButton = ({ imageData }) => {
  const composer = [
    {
      id: 1,
      name: "composer-btn-1",
      src: Send_Btn_1,
    },
    {
      id: 2,
      name: "composer-btn-2",
      src: Send_Btn_2,
    },
    {
      id: 3,
      name: "composer-btn-3",
      src: Send_Btn_3,
    },
    {
      id: 4,
      name: "composer-btn-4",
      src: Send_Btn_4,
    },
    {
      id: 5,
      name: "composer-btn-5",
      src: Avatar_5,
    },
  ];

  const image = composer.find((src) => src.name === imageData);
  return image ? (
    <img style={{ height: "30px", width: "40px" }} src={image?.src} alt="ttt" />
  ) : (
    <p style={{fontWeight:900}}>{imageData}</p>
  );
};

export default SendButton;
